import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import type { Customer, HotelProfile } from '../api/types'

export function Header({
  hotel,
  customer,
  onLogout,
}: {
  hotel?: HotelProfile
  customer: Customer | null
  onLogout: () => void
}) {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="site-header">
      <Link to="/" className="brand">
        {hotel?.logo_image ? (
          <img src={hotel.logo_image} alt={hotel.hotel_name} className="brand-logo" />
        ) : (
          <span className="brand-title">{hotel?.hotel_name || 'Hotel'}</span>
        )}
      </Link>
      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      <nav className={`site-nav ${menuOpen ? 'open' : ''}`}>
        <a href="/#about" onClick={() => setMenuOpen(false)}>
          Esencia
        </a>
        <a href="/#rooms" onClick={() => setMenuOpen(false)}>
          Habitaciones
        </a>
        {hotel?.page_content?.visit.enabled !== false && (
          <a href="/#visit-comayagua" onClick={() => setMenuOpen(false)}>
            Comayagua
          </a>
        )}
        <Link to="/account" onClick={() => setMenuOpen(false)}>
          {customer ? 'Mi Cuenta' : 'Ingresar'}
        </Link>
        {customer ? (
          <button className="nav-button" onClick={() => { onLogout(); setMenuOpen(false) }}>
            Salir
          </button>
        ) : null}
      </nav>
    </header>
  )
}
